import { flagFactory } from '../icon';
import Svg from './gb.svg';

export default flagFactory(Svg);
